import { BannerWrapper, BoldText, DangerIcon, TextContainer } from "./styles";

export default function ExpiredJobBanner() {
  return (
    <BannerWrapper>
      <DangerIcon />
      <TextContainer>
        <BoldText>This job is no longer available.</BoldText> View other similar
        jobs below.
      </TextContainer>
    </BannerWrapper>
  );
}
